import { createWebSupportCategoryNavigationEventFactory } from '@spotify-internal/ubi-sdk-support-spotify-com-web-support-category-navigation';
import { useMemo } from 'react';

import { useUbiContext } from '../ubiProvider';

export const useUbiCategoryNavigation = () => {
  const ubiLogger = useUbiContext();

  const categoryNavigationContainer = createWebSupportCategoryNavigationEventFactory();

  return useMemo(
    () => ({
      logParentCategoryTitleInteraction: ({ expanded, identifier }: { expanded: boolean; identifier: string }) => {
        const parentCategoryInstance = categoryNavigationContainer
          .categoryNavigationContainerFactory()
          .parentCategoryTitleFactory({
            identifier,
          });
        if (expanded) {
          ubiLogger.logInteraction(parentCategoryInstance.hitUiReveal());
        } else {
          ubiLogger.logInteraction(parentCategoryInstance.hitUiHide());
        }
      },
      logChildCategoryTitleInteraction: ({
        expanded,
        parentCategory,
        container,
        identifier,
      }: {
        expanded: boolean;
        parentCategory: string;
        container: string;
        identifier: string;
      }) => {
        const childCategoryInstance = categoryNavigationContainer
          .categoryNavigationContainerFactory()
          .parentCategoryTitleFactory({
            identifier: parentCategory,
          })
          .childCategoryContainerFactory({ identifier: container })
          .childCategoryTitleFactory({
            identifier,
          });
        if (expanded) {
          ubiLogger.logInteraction(childCategoryInstance.hitUiReveal());
        } else {
          ubiLogger.logInteraction(childCategoryInstance.hitUiHide());
        }
      },
      logArticleLinkInteraction: ({
        parentCategory,
        childCategory,
        childCategoryContainer,
        container,
        identifier,
        uri,
      }: {
        parentCategory: string;
        childCategory: string;
        childCategoryContainer: string;
        container: string;
        identifier: string;
        uri: string;
      }) => {
        const urlLinkInstance = categoryNavigationContainer
          .categoryNavigationContainerFactory()
          .parentCategoryTitleFactory({
            identifier: parentCategory,
          })
          .childCategoryContainerFactory({ identifier: childCategoryContainer })
          .childCategoryTitleFactory({
            identifier: childCategory,
          })
          .articleLinksContainerFactory({ identifier: container })
          .articleLinkFactory({
            identifier,
            uri,
          });

        ubiLogger.logInteraction(urlLinkInstance.hitUiNavigate({ destination: uri }));
      },
    }),
    [categoryNavigationContainer, ubiLogger],
  );
};
